import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/about', name: 'about', component: () => import( './views/About.vue')},
    { path: '/Questions', name: 'Questions', component: () => import( './views/Questions.vue')},

    { path: '/notice', name: 'notice', component: () => import( './views/Notice/NoticeList.vue')},
    { path: '/notice/:id', name: 'noticeShow', component: () => import( './views/Notice/NoticeShow.vue')},
    { path: '/noticeWrite', name: 'noticeWrite', meta : { auth: { roles: 'ADMIN', redirect: '/' } }, component: () => import( './views/Notice/NoticeWrite.vue')},
    { path: '/noticeModified', name: 'noticeModified', meta : { auth: { roles: 'ADMIN', redirect: '/' } }, component: () => import( './views/Notice/NoticeModified.vue')},

    { path: '/login', name: 'login', meta : {auth:false}, component: () => import( './views/Login.vue')},
    { path: '/join', name: 'join', meta : {auth:false}, component: () => import( './views/Join.vue')},
    { path: '/forgotpw', name: 'forgotpw', meta : {auth:false}, component: () => import( './views/Forgotpw.vue')},
    { path: '/forgotemail', name: 'forgotEmail', meta : {auth:false}, component: () => import( './views/ForgotEmail.vue')},

    { path: '/auth/email', name: 'authemail', meta : {auth:true}, component: () => import( './views/EmailAuth.vue')},
    { path: '/member/mypage', name: 'mypage', meta : {auth:true}, component: () => import( './views/Member/Mypage.vue')},
    { path: '/member/withdraw', name: 'withdraw', meta : {auth:true}, component: () => import( './views/Member/Withdraw.vue')},
    { path: '/member/change/password', name: 'changepw', meta : {auth:true}, component: () => import( './views/Member/ChangePW.vue')},

    { path: '/activity/regist', name: 'activityRegist', meta : { auth: { roles: 'ADMIN', redirect: '/' } }, component: () => import( './views/Activity/ActivityRegist.vue')},
    { path: '/activity/modify/:id', name: 'activityModify', meta : { auth: { roles: 'ADMIN', redirect: '/' } }, component: () => import( './views/Activity/ActivityRegist.vue')},
    { path: '/activity/:id', name: 'activityShow',  component: () => import( './views/Activity/ActivityShow.vue')},
    { path: '/activity/list/search', name: 'activitySearch',  component: () => import( './views/Activity/ActivitySearch.vue')},

    { path: '/admin/dashboard', name: 'adminIndex', meta : { auth: { roles: 'ADMIN', redirect: '/' } }, component: () => import( './views/Admin/Index.vue')},
    { path: '/admin/activities', name: 'manageAct', meta : { auth: { roles: 'ADMIN', redirect: '/' } }, component: () => import( './views/Admin/ActivityList.vue')},
    { path: '/admin/activity/:id/members', name: 'activityMemberList', meta : { auth: { roles: 'ADMIN', redirect: '/' } }, component: () => import( './views/Admin/ActivityMemberList.vue')},
    { path: '/admin/members', name: 'memberManage', meta : { auth: { roles: 'ADMIN', redirect: '/' } }, component: () => import( './views/Admin/MemberManage.vue')},

    { path: '/qna', name: 'qnaList', component: () => import('./views/Qna/QnaList.vue')},
    { path: '/qna/write', name: 'qnaWrite', meta: { auth: true }, component: () => import('./views/Qna/QnaWrite.vue')},
    { path: '/qna/:id', name: 'qnaShow', component: () => import('./views/Qna/QnaShow.vue')},

    { path: '/archive', name: 'archiveList', component: () => import('./views/Archive/ArchiveList.vue')},
    { path: '/archive/upload', name: 'archiveUpload', meta: { auth: true }, component: () => import('./views/Archive/ArchiveUpload.vue')},
    { path: '/archive/:id', name: 'archiveShow', component: () => import('./views/Archive/ArchiveShow.vue')},
    { path: '/schedule', name: 'scheduleBoard', component: () => import('./views/ScheduleBoardPage.vue')},
    { path: '/terms', name: 'terms', component: () => import('./views/Terms.vue')},
  ],
  scrollBehavior (to, from, savedPosition) {
    if(!$('#navCloseButton').hasClass('collapsed'))
      $('#navCloseButton').click();
    return { x: 0, y: 0 }
  }
})
